import { Box } from '@mantine/core';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainBox = asPlainComponent<ComponentProps<typeof Box>>(Box);

export const SelectedFileBox = styled(PlainBox)`
	padding: 0.75rem;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 4px;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
`;
